import styles from '../ProfileDeatailForInternalExternal/InviteTalentModal/SmsPreviewTemplate.module.css'

const BackChevron = () => (
  <svg className={styles.backChevron} viewBox="0 0 10 16" fill="none">
    <polyline
      points="8,2 2,8 8,14"
      stroke="#000000"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

const ChevronDown = () => (
  <svg className={styles.chevronDown} viewBox="0 0 10 10" fill="none">
    <polyline
      points="3,2 7,5 3,8"
      stroke="#000000"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

const CameraIcon = () => (
  <svg className={styles.cameraIcon} viewBox="0 0 28 22" fill="none">
    <path
      d="M10.8 1.5L9.2 4H3.5C2.12 4 1 5.12 1 6.5V18.5C1 19.88 2.12 21 3.5 21H24.5C25.88 21 27 19.88 27 18.5V6.5C27 5.12 25.88 4 24.5 4H18.8L17.2 1.5H10.8Z"
      fill="#3C3C43"
      fillOpacity="0.6"
    />
    <circle cx="14" cy="13" r="5" fill="white" />
    <circle cx="14" cy="13" r="3.5" fill="#3C3C43" fillOpacity="0.6" />
  </svg>
)

const MicIcon = () => (
  <svg className={styles.micIcon} viewBox="0 0 12 18" fill="none">
    <path
      d="M2.92188 8.4751C2.92188 10.3843 4.15039 11.729 5.94336 11.729C7.72803 11.729 8.95654 10.3843 8.95654 8.4751V3.25391C8.95654 1.33643 7.72803 0 5.94336 0C4.15039 0 2.92188 1.33643 2.92188 3.25391V8.4751ZM4.17529 8.4751V3.25391C4.17529 2.02539 4.88086 1.23682 5.94336 1.23682C7.00586 1.23682 7.70312 2.02539 7.70312 3.25391V8.4751C7.70312 9.70361 7.00586 10.4922 5.94336 10.4922C4.88086 10.4922 4.17529 9.70361 4.17529 8.4751ZM0 8.77393C0 12.0278 2.1499 14.3105 5.3125 14.5762V16.5103H2.23291C1.88428 16.5103 1.60205 16.7925 1.60205 17.1411C1.60205 17.4897 1.88428 17.7637 2.23291 17.7637H9.64551C9.99414 17.7637 10.2764 17.4897 10.2764 17.1411C10.2764 16.7925 9.99414 16.5103 9.64551 16.5103H6.56592V14.5762C9.73682 14.3105 11.8784 12.0278 11.8784 8.77393V7.08887C11.8784 6.74023 11.6045 6.46631 11.2559 6.46631C10.9072 6.46631 10.625 6.74023 10.625 7.08887V8.72412C10.625 11.5547 8.78223 13.4307 5.94336 13.4307C3.09619 13.4307 1.25342 11.5547 1.25342 8.72412V7.08887C1.25342 6.74023 0.979492 6.46631 0.622559 6.46631C0.273926 6.46631 0 6.74023 0 7.08887V8.77393Z"
      fill="#3C3C43"
      fillOpacity="0.6"
    />
  </svg>
)

const SkillGigsAvatar = () => (
  <svg className={styles.sgAvatar} viewBox="0 0 40 40" fill="none">
    <rect width="40" height="40" rx="20" fill="#FC1254" />
    <text x="20" y="25" textAnchor="middle" fill="white" fontSize="13" fontWeight="700">SG</text>
  </svg>
)

const TEMPLATE_CONFIG = {
  'Template 1': {
    intro: (name, title, companyName) =>
      `Hi ${name || '[Candidate First Name]'},\n\nYour invitation for ${title || '[Job Title]'} is still waiting. View:`,
  },
  'Template 2': {
    intro: (name, title, companyName) =>
      `Hi ${name || '[Candidate First Name]'},\n\n${companyName || '[Company]'} is still interested in your profile for ${title || '[Job Title]'}. View:`,
  },
  'Template 3': {
    intro: (name, title, companyName) =>
      `Hi ${name || '[Candidate First Name]'},\n\nFinal reminder: Your invitation for ${title || '[Job Title]'} may close soon.\nView:`,
  },
}

const ReminderSmsPreviewTemplate = ({
  talentFirstName,
  jobTitle,
  jobDetails = [],
  message,
  companyName,
  selectedTemplate = 'Template 1',
}) => {
  const config = TEMPLATE_CONFIG[selectedTemplate] || TEMPLATE_CONFIG['Template 1']
  const intro = config.intro(talentFirstName, jobTitle, companyName)

  return (
    <div className={styles.container}>
      {/* Nav Bar */}
      <div className={styles.navBar}>
        <BackChevron />
        <div className={styles.contactInfo}>
          <SkillGigsAvatar />
          <span className={styles.contactName}>
            Skillgigs
            <ChevronDown />
          </span>
        </div>
      </div>

      {/* Messages */}
      <div className={styles.messagesArea}>
        <div className={styles.timestamp}>Yesterday 9:41</div>
        <div className={styles.bubble}>
          <p style={{ whiteSpace: 'pre-wrap' }}>
            {intro} <span className={styles.link}>[Link]</span>
          </p>
          <p>Reply STOP to opt out.</p>
        </div>
      </div>

      {/* Input Bar */}
      <div className={styles.inputBar}>
        <CameraIcon />
        <div className={styles.inputField}>
          <span>SMS/MMS</span>
          <MicIcon />
        </div>
      </div>

      {/* Home Indicator */}
      <div className={styles.homeIndicator}>
        <div className={styles.homeBar} />
      </div>
    </div>
  )
}

export default ReminderSmsPreviewTemplate
